<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center max-w-md mx-auto px-4">
      <div class="mb-8">
        <div class="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ExclamationTriangleIcon class="w-12 h-12 text-primary-600" />
        </div>
        <h1 class="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 class="text-2xl font-semibold text-gray-700 mb-4">페이지를 찾을 수 없습니다</h2>
        <p class="text-gray-600 mb-8">
          요청하신 페이지가 존재하지 않거나 이동되었습니다.
          아래 버튼을 클릭하여 메인 페이지로 돌아가세요.
        </p>
      </div>
      
      <div class="space-y-3">
        <RouterLink to="/" class="btn btn-primary btn-lg w-full">
          <HomeIcon class="w-5 h-5 mr-2" />
          메인 페이지로 돌아가기
        </RouterLink>
        <button 
          @click="$router.go(-1)"
          class="btn btn-outline btn-lg w-full"
        >
          <ArrowLeftIcon class="w-5 h-5 mr-2" />
          이전 페이지로
        </button>
      </div>
      
      <div class="mt-8">
        <p class="text-sm text-gray-500">
          문제가 지속되면 고객지원에 문의해주세요.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import {
  ExclamationTriangleIcon,
  HomeIcon,
  ArrowLeftIcon
} from '@heroicons/vue/24/outline'
</script>
